<template>
  <div
    class="hero"
    :class="{ layout, slide, 'video-content': video }"
    :style="{ height, position }"
  >
    <img src="@/assets/images/dpsp/logos.png" class="logos" alt="" />

    <div class="text flex-column justify-content-center">
      <h1
        class="text-white m-0"
        data-aos="fade-down"
        data-aos-duration="1000"
        v-html="title"
      ></h1>
    </div>

    <div class="media-content" :class="{ 'v-content': video }">
      <div class="img img-hero" v-if="!slide">
        <img
          :src="require(`@/assets/images/dpsp/${image}`)"
          v-if="image"
          class="rounded shadow-lg w-100"
        />
      </div>
      <div class="bg-video">
        <video autoplay loop="" playsinline="" muted="" id="bgvid" v-if="video">
          <source
            src="https://s3.amazonaws.com/uploads.dpsp.luby.com.br/dpsp-estagio.mp4"
          />
        </video>
      </div>
      <h1
        class="slide-text"
        data-aos="fade-down"
        data-aos-duration="1000"
        v-if="slideTitle"
        v-html="slideTitle"
      ></h1>
      <div
        class="swiper-container swiper2 mySwiper2"
        ref="mySwiper2"
        v-if="slide"
      >
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in slide" :key="index">
            <div class="here-card">
              <div class="container">
                <p v-if="item.title">
                  {{ item.title }}
                </p>
              </div>
              <img
                :src="require(`@/assets/images/dpsp/${item.img}`)"
                v-if="item.img && mobile > 700"
                :class="{ vagas: $route.name == 'jobs' }"
                class="rounded shadow-lg"
              />
              <img
                :src="require(`@/assets/images/dpsp/banner-${index + 1}m.jpg`)"
                v-else-if="item.img && mobile < 700"
                :class="{ vagas: $route.name == 'jobs' }"
                class="rounded shadow-lg"
              />
            </div>
          </div>
        </div>
        <div class="swiper-pagination" ref="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchJob from "@/components/jobs/SearchJob.vue";
import Swiper from "swiper";
// import Swiper styles
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);
export default {
  name: "Hero",

  data() {
    return {
      mobile: "",
    };
  },

  props: {
    title: String,
    slideTitle: String,
    video: String | Boolean,
    search: Boolean,
    image: String,
    layout: String,
    height: null,
    maxHeight: null,
    position: null,
    vagas: false,
    slide: false,
  },

  mounted() {
    this.start();
    this.initMobile();
  },

  methods: {
    initMobile() {
      this.sheekMobileValue();
      window.addEventListener("resize", (e) => {
        this.sheekMobileValue(e.target.outerWidth);
      });
    },
    sheekMobileValue(value) {
      this.mobile = value || window.innerWidth;
    },
    start() {
      var swiper = new Swiper(this.$refs["mySwiper2"], {
        slidesPerView: 1,
        spaceBetween: 0,

        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        pagination: {
          el: this.$refs["swiper-pagination"],
          clickable: true,
        },
        // navigation: {
        //   nextEl: this.$refs["swiper-button-next"],
        //   prevEl: this.$refs["swiper-button-prev"],
        // },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
      });
    },
  },

  components: {
    SearchJob,
  },
};
</script>

<style lang="scss">
.hero {
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 10rem !important;
    @include media-breakpoint-down(md) {
      bottom: 8rem !important;
    }
  }
  .swiper-pagination-bullet {
    background-color: #fff !important;
    border-color: #fff;
    &-active {
      background-color: #2e3447 !important;
      border-color: #2e3447;
    }
  }
}

.swiper-wrapper {
  height: auto;
}

video#bgvid {
  height: 90vh;
  width: 100vw;

  overflow: hidden;
}

.here-card {
  .container {
    position: absolute;
    margin: 0 auto;
    left: 0;
    right: 0;
    background-color: transparent;
    top: 50%;
    height: 100px;
    transform: translateY(-50%);
    z-index: 999;
    box-sizing: border-box;
    text-align: left !important;
  }
  p {
    z-index: 99999;
    color: #fff;
    left: 0;
    max-width: 400px !important;
    margin-left: 3%;
  }
}

.img-hero {
  @include media-breakpoint-down(md) {
    height: auto;
    display: flex;
    justify-content: center;
    text-align: center;
    img {
      height: 60vh !important;
      width: auto !important;
      max-width: 1920px;
      display: block;
      margin: 0 auto;
      margin-left: 0%;
      text-align: center;
    }
  }
  &:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #0000009f 20%, #00000000 100%) 0% 0%
      no-repeat padding-box;
    opacity: 0.4;
  }
}

.bg-video {
  position: relative;
  background-color: #2f3345;
  video {
    width: 100%;
  }
  &:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    // background-color: rgba(#2A2E3E, 0.1);
  }
}

.mySwiper2 {
  width: 100%;
  max-height: calc(100vh - 10px);
  position: relative;
  text-align: center;
  overflow: hidden;
  img {
    max-width: 1920px;
    width: 100%;
    height: auto;
  }
  @include media-breakpoint-down(md) {
    height: auto;
    display: flex;
    justify-content: flex-start;
    text-align: center;
    img {
      width: 100%;
      max-height: 1900px;
    }
  }
  @media screen and (max-width: 600px) {
    img {
      width: 100%;
    }
  }
  @media screen and (max-width: 480px) {
    padding-bottom: 2rem;
  }
  @media screen and (max-width: 380px) {
    padding-bottom: 2rem;
    img {
      &.vagas {
        max-height: 470px;
      }
    }
  }

  z-index: 9;
  position: relative !important;
  .swiper-slide {
    &:after {
      content: "";
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      z-index: 9;
      opacity: 0.7;
      background: linear-gradient(180deg, #0000009f 20%, #00000000 100%) 0% 0%
        no-repeat padding-box;
    }
  }
}

.logos {
  position: absolute;
  left: -12%;
  top: 7.5rem;
  width: 50%;
  max-width: 780px;
  z-index: 99;
  @media screen and (max-width: 1400px) {
    width: 50%;
    max-width: 580px;
  }
}

.hero {
  width: 100vw;
  height: 100vh;
  &.video-content {
    @include media-breakpoint-down(md) {
      height: auto;
    }
  }
  @include media-breakpoint-down(md) {
    height: 60vh !important;
  }
  &.slide {
    height: auto !important;
    position: relative;
    & > .media-content,
    & > .media-content > img,
    & > .media-content > video {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: auto !important;
    }
  }
  top: 0;
  min-height: 400px;
  @include media-breakpoint-down(md) {
    min-height: 100px;
  }
  // max-height: 700px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 9;

  &__vagas {
    width: 80%;
    max-width: 400px;
    text-align: left;
    z-index: 99;
    position: absolute;
    top: 40%;
    @include media-breakpoint-down(md) {
      top: 30%;
    }
    p {
      color: #fff;
      max-width: 400px;
      font-size: 1.2rem;
    }
  }

  &.md {
    height: 40vh;
    min-height: auto;
    overflow: unset;

    & > .media-content {
      width: 100vw;

      top: 0;
      left: 0;
    }
  }

  &.half {
    height: 50vh;
    min-height: auto;
    overflow: unset;

    & > .media-content {
      width: 100vw;

      top: 0;
      left: 0;
    }
  }

  & > .text {
    z-index: 1;
    .input-group {
      .form-control,
      .btn {
        height: calc(4rem + 2px);
        display: flex;

        &::placeholder {
          opacity: 0.5;
        }
      }
    }

    h1 {
      font-size: 3.9rem;
      font-weight: 500;
      text-align: center;
      line-height: calc(3.9rem * 1.3);
      strong {
        font-weight: 600;
        color: theme-color(primary);
      }

      small {
        display: block;
        font-family: "Nunito-light";
        font-size: 2.2rem;
        line-height: calc(2.2rem * 1.1);
      }

      @include media-breakpoint-down(md) {
        font-size: 2rem;
        line-height: calc(2rem * 1.3);
      }
    }
  }

  .slide-text {
    position: absolute;
    font-size: 3.9rem;
    font-weight: 500;
    z-index: 9999;
    top: 40%;
    transform: translate(-50%);
    color: #fff;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
    line-height: calc(3.9rem * 1.3);
    strong {
      font-weight: 600;
      color: theme-color(primary);
    }

    small {
      display: block;
      font-family: "Nunito-light";
      font-size: 2.2rem;
      line-height: calc(2.2rem * 1.1);
    }

    @include media-breakpoint-down(md) {
      font-size: 2rem;
      line-height: calc(2rem * 1.3);
    }
    @media screen and (max-width: 480px) {
      font-size: 1.4rem;
      line-height: calc(1.4rem * 1.3);
      small {
        display: block;
        font-size: 1.4rem;
        line-height: calc(1.4rem * 1.1);
      }
    }
    @media screen and (max-width: 380px) {
      padding-top: 0.3rem;
    }
  }

  & > .media-content,
  & > .media-content > img,
  & > .media-content > video {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: middle;
    overflow: hidden;
    @include media-breakpoint-down(md) {
    }
  }

  & > .media-content.v-content,
  & > .media-content > video {
    @include media-breakpoint-down(md) {
      height: auto !important;
      position: relative !important;
    }
  }

  *::-webkit-media-controls-panel {
    display: none !important;
    -webkit-appearance: none;
  }

  *::--webkit-media-controls-play-button {
    display: none !important;
    -webkit-appearance: none;
  }

  *::-webkit-media-controls-start-playback-button {
    display: none !important;
    -webkit-appearance: none;
  }
}
</style>
